import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecurityDeposit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_1293_1119",
			fill: "white",
			children: /* @__PURE__ */ _jsx("rect", {
				y: 6,
				width: 16,
				height: 9,
				rx: 1
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 6,
			width: 16,
			height: 9,
			rx: 1,
			fill: "white",
			stroke: "#E58181",
			strokeWidth: 4,
			mask: "url(#path-1-inside-1_1293_1119)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3.5,
			y: 1,
			width: 9,
			height: 9,
			rx: 4.5,
			fill: "#F7D9D9",
			stroke: "#E58181",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.79922 3.8999H7.71597C7.54963 3.90002 7.38851 3.95801 7.26025 4.06393C7.13199 4.16985 7.04458 4.3171 7.01302 4.48042C6.98145 4.64373 7.0077 4.81295 7.08725 4.95903C7.16681 5.10512 7.29471 5.21897 7.44903 5.28106L8.55097 5.72205C8.70529 5.78414 8.83319 5.89799 8.91275 6.04408C8.9923 6.19016 9.01855 6.35938 8.98698 6.5227C8.95542 6.68601 8.86801 6.83326 8.73975 6.93918C8.61149 7.0451 8.45037 7.10309 8.28403 7.10321H7.19757",
			stroke: "#E58181",
			strokeWidth: 1.25,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 9.5,
			width: 10,
			height: 2,
			rx: 1,
			fill: "#E58181"
		})
	]
});
export default SvgSecurityDeposit;
